export default "__VITE_ASSET__d3e5b1d6__"